import { render, staticRenderFns } from "./SecureLink.vue?vue&type=template&id=465da392"
import script from "./SecureLink.vue?vue&type=script&lang=js"
export * from "./SecureLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports